import { nanoid } from 'nanoid'

export const SEGMENTS_RURAL = {
  DEFAULT_BUILDING_HEIGHT_LEFT: 5,
  DEFAULT_BUILDING_HEIGHT_RIGHT: 5,
  DEFAULT_BUILDING_VARIANT_LEFT: 'grass',
  DEFAULT_BUILDING_VARIANT_RIGHT: 'grass',
  segments: [
    // { type: 'sidewalk-tree', variant: { 'tree-type': 'big' }, width: 2 },
    // {
    //   type: 'sidewalk-lamp',
    //   variant: {
    //     'lamp-orientation': 'right',
    //     'lamp-type': 'traditional'
    //   },
    //   width: 2
    // },
    // {
    //   type: 'transit-shelter',
    //   variant: {
    //     orientation: 'left',
    //     'transit-shelter-elevation': 'street-level'
    //   },
    //   width: 9
    // },
    // {
    //   type: 'bus-lane',
    //   variant: {
    //     direction: 'inbound',
    //     'bus-asphalt': 'shared',
    //     'bus-type': 'typical'
    //   },
    //   width: 12
    // },
    {
      type: 'drive-lane',
      variant: {
        direction: 'inbound',
        'car-type': 'car'
      },
      width: 11,
      id: nanoid()
    },

    {
      type: 'drive-lane',
      variant: {
        direction: 'outbound',
        'car-type': 'car'
      },
      width: 11,
      id: nanoid()
    }
    // {
    //   type: 'parking-lane',
    //   variant: {
    //     'parking-lane-direction': 'outbound',
    //     'parking-lane-orientation': 'right'
    //   },
    //   width: 7
    // },
    // { type: 'divider', variant: { 'divider-type': 'planter-box' }, width: 4 },
    // {
    //   type: 'bike-lane',
    //   variant: {
    //     direction: 'outbound',
    //     'bike-asphalt': 'green',
    //     elevation: 'road'
    //   },
    //   width: 6
    // },
    // {
    //   type: 'sidewalk-lamp',
    //   variant: {
    //     'lamp-orientation': 'left',
    //     'lamp-type': 'traditional'
    //   },
    //   width: 2
    // },
    // { type: 'sidewalk-tree', variant: { 'tree-type': 'big' }, width: 2 },
  ]
}
